import currencySymbol from './currency';
import humanFriendlyRetexStatus from './humanFriendlyRetexStatus';
import countries from './countries';
import aspenBenefits from './aspenBenefits';
import {
  ONLY_RETURN,
  // ONLY_EXCHANGE,
  RETURN_AND_EXCHANGE
} from './returnExchangeDataset';
import LOGIN_TEMPLATE from './loginPageTemplateIds';

const BASIC_MODE_ECOM_PLATFORM = 'SS_GENERIC_ECOM';

export {
  currencySymbol,
  humanFriendlyRetexStatus,
  countries,
  aspenBenefits,
  ONLY_RETURN,
  // ONLY_EXCHANGE,
  RETURN_AND_EXCHANGE,
  LOGIN_TEMPLATE,
  BASIC_MODE_ECOM_PLATFORM
};
